import React from 'react'
import { Hero } from '../Components/Hero'

export const Home = () => {
  return (
    <>
    <Hero/>
    </>
  )
}
